import { Component, OnInit } from '@angular/core';
import {Router, ActivatedRoute, Params } from '@angular/router';
import {MdSnackBar,MdSnackBarConfig,MdDialog, MdDialogRef} from '@angular/material';

@Component({
  selector: 'app-email-message',
  templateUrl: './email-message.component.html',
  styleUrls: ['./email-message.component.css']
})
export class EmailMessageComponent implements OnInit {
  history :any;
  htmlVariable:any;
  constructor(private router: Router, public dialogRef: MdDialogRef<EmailMessageComponent>) { }
  spinner: boolean = false;

  ngOnInit() {
    this.htmlVariable = this.history.emailContent;
  }
  close() {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/email/email-message/email-message.component.ts